export default __webpack_public_path__ + "static/media/email.cf7c87f7.svg";